<app-complex-modal-template
    class="flex flex-col h-full"
    [canCancel]="true"
    [canConfirm]="!profileForm?.invalid && !!selectedLang()"
    [isConfirmationMode]="isEditMode()"
    [stepNumber]="1"
    [title]="'myProfile' | transloco"
    (onCancelClick)="cancelEdit()"
    (onClickEvent)="closeModal($event)">
    <ng-container>
        @if (!isEditMode()) {
            <app-profile-information
                [selectedLang]="selectedLang()"
                (toggleEditMode)="toggleEditMode()" />
        } @else {
            <app-profile-edition
                [profileForm]="profileForm!"
                [(selectedLang)]="selectedLang" />
        }
    </ng-container>
</app-complex-modal-template>
